import log from "src/helpers/log";

/**
 * Parses likely links in a given text and wraps them in Markdown link syntax.
 */
// Match URLs with protocol, www, or bare domains ending in .com, .net, .org, .edu
const urlRegex =
	/(?:https?:\/\/|www\.)[\w\-._~:/?#\[\]@!$&'()*+,;=%]+|\b[a-zA-Z0-9.-]+\.(?:com|net|org|edu)\b(?!@)/gi;

const parseTextLinks = (text: string): string => {
	try {
		if (!text) return text;
		const replacedText = text.replace(urlRegex, (match) => {
			// Remove trailing punctuation that shouldn't be part of the URL
			const trailing = match.match(/[.,!?)]*$/)?.[0] || "";
			const url = match.slice(0, match.length - trailing.length);
			let hrefUrl = url;
			if (url.startsWith("www.")) {
				hrefUrl = `https://${url}`;
			} else if (!/^https?:\/\//.test(url)) {
				// For bare domains, add https://
				hrefUrl = `https://${url}`;
			}
			return `[${url}](${hrefUrl})${trailing}`;
		});
		return replacedText;
	} catch (err) {
		log.error({ err }, "Error parsing text links");
		return text; // Return original text on error
	}
};

export default parseTextLinks;
